import React, { useContext } from 'react';
import { useParams, Redirect } from 'react-router-dom';

import { SettingsContext, UserContext } from '../../contexts';
import { MerchantSettingsProvider } from '../useMerchantSettings';
import { MerchantSettingsTemplate } from '../templates';

export function MerchantSettingsPage() {
  const { uuid } = useParams();
  const { user } = useContext(UserContext);
  const { merchantUuid } = useContext(SettingsContext);

  if (!user.is_merchant_admin || merchantUuid !== uuid) {
    return null;
  }

  return (
    <MerchantSettingsProvider>
      <MerchantSettingsTemplate />
    </MerchantSettingsProvider>
  );
}
